import React from 'react';
import { TextField } from 'src/components/ui/TextField';

const SingleLineClientForm = (props) => (
    <TextField
        {...props}
        variant="text"
    />
);

export default SingleLineClientForm;
